import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue'

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(PortalVue)
Vue.use(VueMeta)

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    window.vm = new Vue({
      metaInfo: {
        titleTemplate: title => (title ? `${title} - Kreditgenie` : 'Kreditgenie Admin'),
      },
      render: h => h(app, props),
    }).$mount(el)
  },
})
